import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/icon_HiOutlineCalendar.svg'


const _hoisted_1 = { class: "row fit no-wrap justify-center items-end content-start q-pb-md" }
const _hoisted_2 = { class: "col-grow q-pr-lg" }
const _hoisted_3 = { style: {"width":"160px"} }
const _hoisted_4 = { class: "row items-center justify-end" }
const _hoisted_5 = { style: {"width":"160px"} }
const _hoisted_6 = { class: "row items-center justify-end" }
const _hoisted_7 = { class: "row q-pb-md" }
const _hoisted_8 = { class: "col-6" }

import { useInstitutionalStore } from '@/stores/institutionalStore';
import { ref, computed, onMounted } from 'vue'
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import ButtonCloseModal from '@/components/ButtonCloseModal.vue'
import { useAuthStore } from '@/stores/authStore'
import type { InstitutionalDraft } from '@/stores/institutionalStore';
import type { TelasInstitucionaisModel } from '@/models/TelasInstitucionaisModel';



export default /*@__PURE__*/_defineComponent({
  __name: 'InstitutionalIdentificationSectionEdit',
  setup(__props) {

const qPopupProxyStartDate: { value: QPopupProxy | null } = ref(null)
const qPopupProxyEndDate: { value: QPopupProxy | null } = ref(null)

const startDateInternal = ref('')
const endDateInternal = ref('')

const authStore = useAuthStore()

const perfilOptions = computed(() => {
  return ['Banco24Horas', 'ATM Manager']
})

const perfilDisabled = computed(() => {
  return !authStore.currentUserRoles.userIsAdmin
})





const updateStartDate = () => {
  const target = institutionalStore.institutionalDetail ?? institutionalStore.institutionalDraft;

  if (target && target.dtIniVigencia) {
    startDateInternal.value =
      target.dtIniVigencia.split('/').reverse().join('-');
  }
};

const updateStartDateFormatted = () => {
  const target = institutionalStore.institutionalDetail ?? institutionalStore.institutionalDraft;

  if (target && startDateInternal.value) {
    target.dtIniVigencia =
      startDateInternal.value.split('-').reverse().join('/');
  }

  qPopupProxyStartDate.value?.hide();
};


const updateEndDate = () => {
  const target =
    institutionalStore.institutionalDetail ??
    institutionalStore.institutionalDraft;

  if (target && target.dtFimVigencia) {
    endDateInternal.value =
      target.dtFimVigencia.split('/').reverse().join('-');
  }
};


const updateEndDateFormatted = () => {
  const target =
    institutionalStore.institutionalDetail ??
    institutionalStore.institutionalDraft;

  if (target && endDateInternal.value) {
    target.dtFimVigencia =
      endDateInternal.value.split('-').reverse().join('/');
  }

  qPopupProxyEndDate.value?.hide();
};




const formData = computed<TelasInstitucionaisModel | InstitutionalDraft>(() => {
  return institutionalStore.institutionalDetail || institutionalStore.institutionalDraft;
});


onMounted(() => {
  const perfil = authStore.currentUserInstitutionalProfile;

  const target =
    institutionalStore.institutionalDetail ??
    institutionalStore.institutionalDraft;

  if (!target) return;

  if (perfil === 'B24H') {
    target.perfil = 'Banco24Horas';
  }

  if (perfil === 'ATMM') {
    target.perfil = 'ATM Manager';
  }

  syncDatesFromBackend();
});

const formatToBR = (date?: string | null) => {
  if (!date) return '';

  // já está certo
  if (date.includes('/')) return date;

  // formato backend YYYY-MM-DD
  if (date.includes('-')) {
    return date.split('-').reverse().join('/');
  }

  return date;
};

const syncDatesFromBackend = () => {
  const target =
    institutionalStore.institutionalDetail ??
    institutionalStore.institutionalDraft;

  if (!target) return;

  target.dtIniVigencia = formatToBR(target.dtIniVigencia);
  target.dtFimVigencia = formatToBR(target.dtFimVigencia);

  // sincroniza também o internal (calendar)
  if (target.dtIniVigencia) {
    startDateInternal.value =
      target.dtIniVigencia.split('/').reverse().join('-');
  }

  if (target.dtFimVigencia) {
    endDateInternal.value =
      target.dtFimVigencia.split('/').reverse().join('-');
  }
};

const institutionalStore = useInstitutionalStore();

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "midia-app-caption-sm" }, "Nome do Cadastro *", -1)),
        _createVNode(_component_q_input, {
          modelValue: formData.value.nome,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.nome) = $event)),
          outlined: "",
          dense: "",
          placeholder: "Informe o nome do cadastro"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "midia-app-caption-sm" }, "Período de Vigência *", -1)),
        _createVNode(_component_q_input, {
          style: {"outline":"1px solid var(--globalAppSecondaryColor2)"},
          modelValue: formData.value.dtIniVigencia,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((formData.value.dtIniVigencia) = $event)),
            updateStartDate
          ],
          mask: "##/##/####",
          borderless: "",
          dense: ""
        }, {
          prepend: _withCtx(() => [
            _createVNode(_component_q_icon, {
              class: "cursor-pointer q-pa-sm q-mr-sm",
              style: {"background":"var(--globalAppPrimaryColor)"}
            }, {
              default: _withCtx(() => [
                _cache[7] || (_cache[7] = _createElementVNode("img", {
                  class: "svg-icon",
                  src: _imports_0
                }, null, -1)),
                _createVNode(_unref(QPopupProxy), {
                  ref_key: "qPopupProxyStartDate",
                  ref: qPopupProxyStartDate,
                  cover: "",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: startDateInternal.value,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((startDateInternal).value = $event)),
                        updateStartDateFormatted
                      ],
                      mask: "YYYY-MM-DD",
                      minimal: "",
                      color: "globalAppPrimaryColor"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(ButtonCloseModal)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "q-px-sm q-pb-sm" }, [
        _createElementVNode("span", { class: "midia-app-caption-sm" }, "até")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_q_input, {
          style: {"outline":"1px solid var(--globalAppSecondaryColor2)"},
          modelValue: formData.value.dtFimVigencia,
          "onUpdate:modelValue": [
            _cache[4] || (_cache[4] = ($event: any) => ((formData.value.dtFimVigencia) = $event)),
            updateEndDate
          ],
          mask: "##/##/####",
          borderless: "",
          dense: ""
        }, {
          prepend: _withCtx(() => [
            _createVNode(_component_q_icon, {
              class: "cursor-pointer q-pa-sm q-mr-sm",
              style: {"background":"var(--globalAppPrimaryColor)"}
            }, {
              default: _withCtx(() => [
                _cache[9] || (_cache[9] = _createElementVNode("img", {
                  class: "svg-icon",
                  src: _imports_0
                }, null, -1)),
                _createVNode(_unref(QPopupProxy), {
                  ref_key: "qPopupProxyEndDate",
                  ref: qPopupProxyEndDate,
                  cover: "",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: endDateInternal.value,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => ((endDateInternal).value = $event)),
                        updateEndDateFormatted
                      ],
                      mask: "YYYY-MM-DD",
                      minimal: "",
                      color: "globalAppPrimaryColor"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(ButtonCloseModal)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "midia-app-caption-sm" }, "Perfil *", -1)),
        _createVNode(_component_q_select, {
          modelValue: formData.value.perfil,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.perfil) = $event)),
          outlined: "",
          dense: "",
          options: ['Banco24Horas', 'ATM Manager'],
          disable: _unref(authStore).currentUserInstitutionalProfile !== 'ADMIN'
        }, null, 8, ["modelValue", "disable"])
      ])
    ])
  ]))
}
}

})